<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" class="py-0">
        <v-img
          :min-height="minHeight"
          :src="require('@/assets/cta2.jpg')"
          class="white--text"
          gradient="to right, rgba(5, 11, 31, .05), rgba(5, 11, 31, .05)"
        >
        </v-img>
      </v-col>
      <v-col cols="12" md="6">
        <v-container class="fill-height px-12">
          <div class="text-left py-6">
            <v-img
              alt="Together Logo"
              class="shrink mt-1 hidden-sm-and-down pb-8"
              contain
              min-width="100"
              :src="require('@/assets/techsoup_together_logo_orange.png')"
              width="150"
            />
            <h3 class="mb-4 display-1">
              Insieme si cresce. <br>Pronto a unirti? <br>
              Inizia il tuo percorso
            </h3>
            <v-btn
              color="primary"
              class="uppercase mt-2"
              to="/signup"
              large
            >Crea un account</v-btn>
            <p
              class="font-weight-light body-2 mt-3"
            >Inizia subito senza impegno. Se non fa per te, disdici quando vuoi.</p>
          </div>
        </v-container>
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </div>
</template>

<script>
export default {
  name: "Cta2Section",

  computed: {
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? "80vh" : "50vh";

      return `calc(${height} - ${this.$vuetify.application.top}px)`;
    }
  }
};
</script>
